export const GetMarketLoggedInForm =
  "/Inv_InvestmentMarketView/GetInvestmentMarketForm";

export const GetInvestmentMarketList = ({
  brokerId = 0,
  coinSourceId = -1,
  coinDestinationId = -1,
}) =>
  `/Inv_InvestmentMarketView/GetInvestmentMarketList?BrokerId=${brokerId}&CoinSourceId=${coinSourceId}&CoinDestinationId=${coinDestinationId}`;

export const GetInvestmentMarketWithAccountBrokerList = ({
  brokerId = 0,
  coinSourceId = -1,
  coinDestinationId = -1,
}) =>
  `/Inv_InvestmentMarketView/GetInvestmentMarketWithAccountBrokerList?AccountBrokerId=${brokerId}&CoinSourceId=${coinSourceId}&CoinDestinationId=${coinDestinationId}`;

export const GetSingleMarketLoggedInList = ({
  coinSourceId,
  coinDestinationId,
  brokerId,
}) =>
  `/Inv_InvestmentMarketView/GetInvestmentMarketList?BrokerId=${brokerId}&CoinSourceId=${coinSourceId}&CoinDestinationId=${coinDestinationId}`;

export const GetInvestmentMarket = ({
  brokerId = 0,
  coinSourceId = -1,
  coinDestinationId = -1,
}) =>
  `/Inv_InvestmentMarketView/GetInvestmentMarket?BrokerId=${brokerId}&CoinSourceId=${coinSourceId}&CoinDestinationId=${coinDestinationId}`;

export const GetInvestmentMarketWithAccountBroker = ({
  brokerId = 0,
  coinSourceId = -1,
  coinDestinationId = -1,
}) =>
  `/Inv_InvestmentMarketView/GetInvestmentMarketWithAccountBroker?AccountBrokerId=${brokerId}&CoinSourceId=${coinSourceId}&CoinDestinationId=${coinDestinationId}`;
